export default "__VITE_ASSET__D3Lis5HC__"